"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validateLength;

var _validateMaxLength = _interopRequireDefault(require("./validateMaxLength"));

var _validateMinLength = _interopRequireDefault(require("./validateMinLength"));

function validateLength(v, fields, options) {
  var _ref = options || {},
      max = _ref.max,
      min = _ref.min;

  v = Object.assign({}, v);

  if (max !== undefined && max !== null) {
    v = (0, _validateMaxLength["default"])(v, fields, options);
  }

  if (min !== undefined && min !== null) {
    v = (0, _validateMinLength["default"])(v, fields, options);
  }

  return v;
}